import clsx from 'clsx';
import React, { forwardRef, useCallback } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { button as buttonClass, icon as iconClass } from './button.module.css';
import { Icon } from '../icon';
export const Button = forwardRef(({ kind = 'primary', dimension = 'regular', contentAlign = 'center', as = 'button', className, children, fullWidth, icon, disabled, noBorder = false, capitalize = true, iconRight, type = 'button', href = '#', target = '_self', rel = 'noopener', style, onClick, ...props }, forwardedRef) => {
    const handleClick = useCallback(() => (event) => {
        if (!disabled && onClick)
            onClick(event);
        if (disabled)
            event.preventDefault();
    }, [disabled, onClick]);
    const cssVars = {
        '--button-content-align': contentAlign,
    };
    const Comp = as === 'a' ? 'a' : Slot;
    const linkProps = as === 'a' ? { href, target, rel } : {};
    return (React.createElement(Comp, { ...linkProps },
        React.createElement("button", { ref: forwardedRef, className: clsx(buttonClass, className), type: type, "data-button-dimension": dimension, "data-button-kind": kind, "data-button-fullwidth": fullWidth, "data-button-disabled": disabled, "data-button-icon-right": iconRight, "data-no-border": noBorder, "data-capitalize": capitalize, "aria-disabled": disabled, style: { ...cssVars, ...style }, onClick: handleClick(), ...props },
            icon && React.createElement(Icon, { className: iconClass, name: icon }),
            children && React.createElement("span", null, children))));
});
Button.displayName = 'Button';
